export const RESTRICTION_TYPE_IDS = {
    CLASSIC: 'classic',
    FAST: 'FAST',
    LOCAL_VOD: 'local_vod',
} as const;

export interface Country {
    id: string;
    parentId?: string;
    label: string;
    active: boolean;
    restrictionType: string[];
    description: string;
}

export interface Zone {
    id: string;
    label: string;
    active: boolean;
    countries: Country[];
}

export const ZONES_DATA: Zone[] = [
    {
        id: 'europ',
        label: 'ScreeningRoom.modal.restrictedCountry.zone.europ',
        active: false,
        countries: [
            { id: 'AD', label: 'IsoCountry.AD', active: false, restrictionType: [''], description: '' },
            { id: 'AL', label: 'IsoCountry.AL', active: false, restrictionType: [''], description: '' },
            { id: 'AM', label: 'IsoCountry.AM', active: false, restrictionType: [''], description: '' },
            { id: 'AT', label: 'IsoCountry.AT', active: false, restrictionType: [''], description: '' },
            { id: 'AZ', label: 'IsoCountry.AZ', active: false, restrictionType: [''], description: '' },
            { id: 'BA', label: 'IsoCountry.BA', active: false, restrictionType: [''], description: '' },
            { id: 'BE', label: 'IsoCountry.BE', active: false, restrictionType: [''], description: '' },
            { id: 'BG', label: 'IsoCountry.BG', active: false, restrictionType: [''], description: '' },
            { id: 'BY', label: 'IsoCountry.BY', active: false, restrictionType: [''], description: '' },
            { id: 'CH', label: 'IsoCountry.CH', active: false, restrictionType: [''], description: '' },
            { id: 'CY', label: 'IsoCountry.CY', active: false, restrictionType: [''], description: '' },
            { id: 'CZ', label: 'IsoCountry.CZ', active: false, restrictionType: [''], description: '' },
            { id: 'DE', label: 'IsoCountry.DE', active: false, restrictionType: [''], description: '' },
            { id: 'DK', label: 'IsoCountry.DK', active: false, restrictionType: [''], description: '' },
            { id: 'EE', label: 'IsoCountry.EE', active: false, restrictionType: [''], description: '' },
            { id: 'ES', label: 'IsoCountry.ES', active: false, restrictionType: [''], description: '' },
            { id: 'FI', label: 'IsoCountry.FI', active: false, restrictionType: [''], description: '' },
            { id: 'FR', label: 'IsoCountry.FR', active: false, restrictionType: [''], description: '' },
            { id: 'GB', label: 'IsoCountry.GB', active: false, restrictionType: [''], description: '' },
            { id: 'GE', label: 'IsoCountry.GE', active: false, restrictionType: [''], description: '' },
            { id: 'GR', label: 'IsoCountry.GR', active: false, restrictionType: [''], description: '' },
            { id: 'HR', label: 'IsoCountry.HR', active: false, restrictionType: [''], description: '' },
            { id: 'HU', label: 'IsoCountry.HU', active: false, restrictionType: [''], description: '' },
            { id: 'IE', label: 'IsoCountry.IE', active: false, restrictionType: [''], description: '' },
            { id: 'IS', label: 'IsoCountry.IS', active: false, restrictionType: [''], description: '' },
            { id: 'IT', label: 'IsoCountry.IT', active: false, restrictionType: [''], description: '' },
            { id: 'LI', label: 'IsoCountry.LI', active: false, restrictionType: [''], description: '' },
            { id: 'LT', label: 'IsoCountry.LT', active: false, restrictionType: [''], description: '' },
            { id: 'LU', label: 'IsoCountry.LU', active: false, restrictionType: [''], description: '' },
            { id: 'LV', label: 'IsoCountry.LV', active: false, restrictionType: [''], description: '' },
            { id: 'MC', label: 'IsoCountry.MC', active: false, restrictionType: [''], description: '' },
            { id: 'MD', label: 'IsoCountry.MD', active: false, restrictionType: [''], description: '' },
            { id: 'ME', label: 'IsoCountry.ME', active: false, restrictionType: [''], description: '' },
            { id: 'MK', label: 'IsoCountry.MK', active: false, restrictionType: [''], description: '' },
            { id: 'MT', label: 'IsoCountry.MT', active: false, restrictionType: [''], description: '' },
            { id: 'NL', label: 'IsoCountry.NL', active: false, restrictionType: [''], description: '' },
            { id: 'NO', label: 'IsoCountry.NO', active: false, restrictionType: [''], description: '' },
            { id: 'PL', label: 'IsoCountry.PL', active: false, restrictionType: [''], description: '' },
            { id: 'PT', label: 'IsoCountry.PT', active: false, restrictionType: [''], description: '' },
            { id: 'RO', label: 'IsoCountry.RO', active: false, restrictionType: [''], description: '' },
            { id: 'RS', label: 'IsoCountry.RS', active: false, restrictionType: [''], description: '' },
            { id: 'RU', label: 'IsoCountry.RU', active: false, restrictionType: [''], description: '' },
            { id: 'SE', label: 'IsoCountry.SE', active: false, restrictionType: [''], description: '' },
            { id: 'SI', label: 'IsoCountry.SI', active: false, restrictionType: [''], description: '' },
            { id: 'SK', label: 'IsoCountry.SK', active: false, restrictionType: [''], description: '' },
            { id: 'TR', label: 'IsoCountry.TR', active: false, restrictionType: [''], description: '' },
            { id: 'UA', label: 'IsoCountry.UA', active: false, restrictionType: [''], description: '' },
            { id: 'XK', label: 'IsoCountry.XK', active: false, restrictionType: [''], description: '' },
            {
                id: 'YT',
                label: 'IsoCountry.YT',
                active: false,
                restrictionType: [''],
                description: 'IsoCountryDesc.YT',
            },
        ],
    },
    {
        id: 'northAmerica',
        label: 'ScreeningRoom.modal.restrictedCountry.zone.northAmerica',
        active: false,
        countries: [
            { id: 'US', label: 'IsoCountry.US', active: false, restrictionType: [''], description: '' },
            { id: 'CA', label: 'IsoCountry.CA', active: false, restrictionType: [''], description: '' },
        ],
    },
    {
        id: 'apac',
        label: 'ScreeningRoom.modal.restrictedCountry.zone.apac',
        active: false,
        countries: [
            { id: 'AS', label: 'IsoCountry.AS', active: false, restrictionType: [''], description: '' },
            { id: 'AU', label: 'IsoCountry.AU', active: false, restrictionType: [''], description: '' },
            { id: 'BN', label: 'IsoCountry.BN', active: false, restrictionType: [''], description: '' },
            {
                id: 'CK',
                label: 'IsoCountry.CK',
                active: false,
                restrictionType: [''],
                description: 'IsoCountryDesc.CK',
            },
            { id: 'CN', label: 'IsoCountry.CN', active: false, restrictionType: [''], description: '' },
            { id: 'HK', label: 'IsoCountry.HK', active: false, restrictionType: [''], description: '' },
            { id: 'ID', label: 'IsoCountry.ID', active: false, restrictionType: [''], description: '' },
            { id: 'JP', label: 'IsoCountry.JP', active: false, restrictionType: [''], description: '' },
            { id: 'KH', label: 'IsoCountry.KH', active: false, restrictionType: [''], description: '' },
            { id: 'KP', label: 'IsoCountry.KP', active: false, restrictionType: [''], description: '' },
            { id: 'KR', label: 'IsoCountry.KR', active: false, restrictionType: [''], description: '' },
            { id: 'LA', label: 'IsoCountry.LA', active: false, restrictionType: [''], description: '' },
            { id: 'MM', label: 'IsoCountry.MM', active: false, restrictionType: [''], description: '' },
            { id: 'MN', label: 'IsoCountry.MN', active: false, restrictionType: [''], description: '' },
            { id: 'MO', label: 'IsoCountry.MO', active: false, restrictionType: [''], description: '' },
            { id: 'MY', label: 'IsoCountry.MY', active: false, restrictionType: [''], description: '' },
            { id: 'NZ', label: 'IsoCountry.NZ', active: false, restrictionType: [''], description: '' },
            { id: 'PH', label: 'IsoCountry.PH', active: false, restrictionType: [''], description: '' },
            { id: 'SG', label: 'IsoCountry.SG', active: false, restrictionType: [''], description: '' },
            { id: 'TH', label: 'IsoCountry.TH', active: false, restrictionType: [''], description: '' },
            { id: 'TL', label: 'IsoCountry.TL', active: false, restrictionType: [''], description: '' },
            { id: 'TW', label: 'IsoCountry.TW', active: false, restrictionType: [''], description: '' },
            { id: 'VN', label: 'IsoCountry.VN', active: false, restrictionType: [''], description: '' },
        ],
    },
    {
        id: 'indianSub',
        label: 'ScreeningRoom.modal.restrictedCountry.zone.indianSub',
        active: false,
        countries: [
            { id: 'AF', label: 'IsoCountry.AF', active: false, restrictionType: [''], description: '' },
            { id: 'BD', label: 'IsoCountry.BD', active: false, restrictionType: [''], description: '' },
            { id: 'BT', label: 'IsoCountry.BT', active: false, restrictionType: [''], description: '' },
            { id: 'IN', label: 'IsoCountry.IN', active: false, restrictionType: [''], description: '' },
            { id: 'LK', label: 'IsoCountry.LK', active: false, restrictionType: [''], description: '' },
            { id: 'MV', label: 'IsoCountry.MV', active: false, restrictionType: [''], description: '' },
            { id: 'NP', label: 'IsoCountry.NP', active: false, restrictionType: [''], description: '' },
            { id: 'PK', label: 'IsoCountry.PK', active: false, restrictionType: [''], description: '' },
        ],
    },
    {
        id: 'latinAmerica',
        label: 'ScreeningRoom.modal.restrictedCountry.zone.latinAmerica',
        active: false,
        countries: [
            {
                id: 'AG',
                label: 'IsoCountry.AG',
                active: false,
                restrictionType: [''],
                description: 'IsoCountryDesc.AG',
            },
            { id: 'AR', label: 'IsoCountry.AR', active: false, restrictionType: [''], description: '' },
            { id: 'BO', label: 'IsoCountry.BO', active: false, restrictionType: [''], description: '' },
            { id: 'BR', label: 'IsoCountry.BR', active: false, restrictionType: [''], description: '' },
            { id: 'BZ', label: 'IsoCountry.BZ', active: false, restrictionType: [''], description: '' },
            { id: 'CL', label: 'IsoCountry.CL', active: false, restrictionType: [''], description: '' },
            { id: 'CO', label: 'IsoCountry.CO', active: false, restrictionType: [''], description: '' },
            { id: 'CR', label: 'IsoCountry.CR', active: false, restrictionType: [''], description: '' },
            { id: 'CU', label: 'IsoCountry.CU', active: false, restrictionType: [''], description: '' },
            { id: 'EC', label: 'IsoCountry.EC', active: false, restrictionType: [''], description: '' },
            { id: 'GT', label: 'IsoCountry.GT', active: false, restrictionType: [''], description: '' },
            { id: 'GY', label: 'IsoCountry.GY', active: false, restrictionType: [''], description: '' },
            { id: 'HN', label: 'IsoCountry.HN', active: false, restrictionType: [''], description: '' },
            { id: 'HT', label: 'IsoCountry.HT', active: false, restrictionType: [''], description: '' },
            { id: 'MX', label: 'IsoCountry.MX', active: false, restrictionType: [''], description: '' },
            { id: 'NI', label: 'IsoCountry.NI', active: false, restrictionType: [''], description: '' },
            { id: 'PA', label: 'IsoCountry.PA', active: false, restrictionType: [''], description: '' },
            { id: 'PE', label: 'IsoCountry.PE', active: false, restrictionType: [''], description: '' },
            { id: 'PY', label: 'IsoCountry.PY', active: false, restrictionType: [''], description: '' },
            { id: 'SR', label: 'IsoCountry.SR', active: false, restrictionType: [''], description: '' },
            { id: 'SV', label: 'IsoCountry.SV', active: false, restrictionType: [''], description: '' },
            { id: 'UY', label: 'IsoCountry.UY', active: false, restrictionType: [''], description: '' },
            { id: 'VE', label: 'IsoCountry.VE', active: false, restrictionType: [''], description: '' },
        ],
    },
    {
        id: 'mena',
        label: 'ScreeningRoom.modal.restrictedCountry.zone.mena',
        active: false,
        countries: [
            { id: 'AE', label: 'IsoCountry.AE', active: false, restrictionType: [''], description: '' },
            { id: 'BH', label: 'IsoCountry.BH', active: false, restrictionType: [''], description: '' },
            { id: 'DZ', label: 'IsoCountry.DZ', active: false, restrictionType: [''], description: '' },
            { id: 'EG', label: 'IsoCountry.EG', active: false, restrictionType: [''], description: '' },
            { id: 'IL', label: 'IsoCountry.IL', active: false, restrictionType: [''], description: '' },
            { id: 'IQ', label: 'IsoCountry.IQ', active: false, restrictionType: [''], description: '' },
            { id: 'IR', label: 'IsoCountry.IR', active: false, restrictionType: [''], description: '' },
            { id: 'JO', label: 'IsoCountry.JO', active: false, restrictionType: [''], description: '' },
            { id: 'KW', label: 'IsoCountry.KW', active: false, restrictionType: [''], description: '' },
            { id: 'LB', label: 'IsoCountry.LB', active: false, restrictionType: [''], description: '' },
            { id: 'LY', label: 'IsoCountry.LY', active: false, restrictionType: [''], description: '' },
            { id: 'MA', label: 'IsoCountry.MA', active: false, restrictionType: [''], description: '' },
            { id: 'OM', label: 'IsoCountry.OM', active: false, restrictionType: [''], description: '' },
            { id: 'PS', label: 'IsoCountry.PS', active: false, restrictionType: [''], description: '' },
            { id: 'QA', label: 'IsoCountry.QA', active: false, restrictionType: [''], description: '' },
            { id: 'SA', label: 'IsoCountry.SA', active: false, restrictionType: [''], description: '' },
            { id: 'SD', label: 'IsoCountry.SD', active: false, restrictionType: [''], description: '' },
            { id: 'SY', label: 'IsoCountry.SY', active: false, restrictionType: [''], description: '' },
            { id: 'TN', label: 'IsoCountry.TN', active: false, restrictionType: [''], description: '' },
            { id: 'YE', label: 'IsoCountry.YE', active: false, restrictionType: [''], description: '' },
        ],
    },
    {
        id: 'ssa',
        label: 'ScreeningRoom.modal.restrictedCountry.zone.ssa',
        active: false,
        countries: [
            { id: 'AO', label: 'IsoCountry.AO', active: false, restrictionType: [''], description: '' },
            { id: 'BF', label: 'IsoCountry.BF', active: false, restrictionType: [''], description: '' },
            { id: 'BI', label: 'IsoCountry.BI', active: false, restrictionType: [''], description: '' },
            { id: 'BJ', label: 'IsoCountry.BJ', active: false, restrictionType: [''], description: '' },
            { id: 'BW', label: 'IsoCountry.BW', active: false, restrictionType: [''], description: '' },
            { id: 'CD', label: 'IsoCountry.CD', active: false, restrictionType: [''], description: '' },
            { id: 'CF', label: 'IsoCountry.CF', active: false, restrictionType: [''], description: '' },
            { id: 'CG', label: 'IsoCountry.CG', active: false, restrictionType: [''], description: '' },
            { id: 'CI', label: 'IsoCountry.CI', active: false, restrictionType: [''], description: '' },
            { id: 'CM', label: 'IsoCountry.CM', active: false, restrictionType: [''], description: '' },
            { id: 'CV', label: 'IsoCountry.CV', active: false, restrictionType: [''], description: '' },
            { id: 'DJ', label: 'IsoCountry.DJ', active: false, restrictionType: [''], description: '' },
            { id: 'ER', label: 'IsoCountry.ER', active: false, restrictionType: [''], description: '' },
            { id: 'ET', label: 'IsoCountry.ET', active: false, restrictionType: [''], description: '' },
            { id: 'GA', label: 'IsoCountry.GA', active: false, restrictionType: [''], description: '' },
            { id: 'GH', label: 'IsoCountry.GH', active: false, restrictionType: [''], description: '' },
            { id: 'GM', label: 'IsoCountry.GM', active: false, restrictionType: [''], description: '' },
            { id: 'GN', label: 'IsoCountry.GN', active: false, restrictionType: [''], description: '' },
            { id: 'GQ', label: 'IsoCountry.GQ', active: false, restrictionType: [''], description: '' },
            { id: 'GW', label: 'IsoCountry.GW', active: false, restrictionType: [''], description: '' },
            { id: 'KE', label: 'IsoCountry.KE', active: false, restrictionType: [''], description: '' },
            { id: 'KM', label: 'IsoCountry.KM', active: false, restrictionType: [''], description: '' },
            { id: 'LR', label: 'IsoCountry.LR', active: false, restrictionType: [''], description: '' },
            { id: 'LS', label: 'IsoCountry.LS', active: false, restrictionType: [''], description: '' },
            { id: 'MG', label: 'IsoCountry.MG', active: false, restrictionType: [''], description: '' },
            { id: 'ML', label: 'IsoCountry.ML', active: false, restrictionType: [''], description: '' },
            { id: 'MR', label: 'IsoCountry.MR', active: false, restrictionType: [''], description: '' },
            { id: 'MU', label: 'IsoCountry.MU', active: false, restrictionType: [''], description: '' },
            { id: 'MW', label: 'IsoCountry.MW', active: false, restrictionType: [''], description: '' },
            { id: 'MZ', label: 'IsoCountry.MZ', active: false, restrictionType: [''], description: '' },
            { id: 'NA', label: 'IsoCountry.NA', active: false, restrictionType: [''], description: '' },
            { id: 'NE', label: 'IsoCountry.NE', active: false, restrictionType: [''], description: '' },
            { id: 'NG', label: 'IsoCountry.NG', active: false, restrictionType: [''], description: '' },
            { id: 'RW', label: 'IsoCountry.RW', active: false, restrictionType: [''], description: '' },
            { id: 'SC', label: 'IsoCountry.SC', active: false, restrictionType: [''], description: '' },
            { id: 'SL', label: 'IsoCountry.SL', active: false, restrictionType: [''], description: '' },
            { id: 'SN', label: 'IsoCountry.SN', active: false, restrictionType: [''], description: '' },
            { id: 'SO', label: 'IsoCountry.SO', active: false, restrictionType: [''], description: '' },
            { id: 'SS', label: 'IsoCountry.SS', active: false, restrictionType: [''], description: '' },
            { id: 'ST', label: 'IsoCountry.ST', active: false, restrictionType: [''], description: '' },
            { id: 'SZ', label: 'IsoCountry.SZ', active: false, restrictionType: [''], description: '' },
            { id: 'TD', label: 'IsoCountry.TD', active: false, restrictionType: [''], description: '' },
            { id: 'TG', label: 'IsoCountry.TG', active: false, restrictionType: [''], description: '' },
            { id: 'TZ', label: 'IsoCountry.TZ', active: false, restrictionType: [''], description: '' },
            { id: 'UG', label: 'IsoCountry.UG', active: false, restrictionType: [''], description: '' },
            { id: 'ZA', label: 'IsoCountry.ZA', active: false, restrictionType: [''], description: '' },
            { id: 'ZM', label: 'IsoCountry.ZM', active: false, restrictionType: [''], description: '' },
            { id: 'ZW', label: 'IsoCountry.ZW', active: false, restrictionType: [''], description: '' },
        ],
    },
];

export const createInitialZonesState = () => {
    return JSON.parse(JSON.stringify(ZONES_DATA));
};

export const getAllCountries = (): Country[] => {
    return ZONES_DATA.flatMap((zone) =>
        zone.countries.map((country) => ({
            ...country,
            parentId: zone.id,
        })),
    );
};

export const ZONE_IDS = {
    EUROPE: 'europ',
    APAC: 'apac',
    INDIAN_SUB: 'indianSub',
    LATIN_AMERICA: 'latinAmerica',
    MENA: 'mena',
    SSA: 'ssa',
} as const;

export default ZONES_DATA;
